<template>
    <div class="member-information">
        <div class="common-header-wrap">
            <mt-header title="إضافة رد" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="form">
            <mt-field label="تعليمات الاسترداد" v-model="buyer_message" type="textarea" />
            <mt-cell title="قسيمة استرداد" ></mt-cell>
            <div class="image-wrapper">
                <div class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadRefundImage(0,$event)">
                    <img v-if="image[0]" :src="image[0]">
                    <input type="file" accept="image/*">
                </div>
                <div class="user-avatar iconfont icon-xiangji" ref="upload_btn2" @change="uploadRefundImage(1,$event)">
                    <img v-if="image[1]" :src="image[1]">
                    <input type="file" accept="image/*">
                </div>
                <div class="user-avatar iconfont icon-xiangji" ref="upload_btn3" @change="uploadRefundImage(2,$event)">
                    <img v-if="image[2]" :src="image[2]">
                    <input type="file" accept="image/*">
                </div>
            </div>
            <mt-button class="ds-button-large mt-10" type="primary" @click="submitInformation">حفظ</mt-button>
        </div>
        <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="قص الصورة" class="common-header">
                    <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
                    <mt-button slot="right" @click="useCrop">استعمال</mt-button>
                </mt-header>
            </div>
            <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
        </mt-popup>
    </div>
</template>

<script>

import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'

import { uploadRefundImage, addRefundAll } from '../../../api/memberRefund'
export default {
  components: {
    VueCropper
  },
  name: 'MemberRefundForm',
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      cropType: '',
      order_id: this.$route.query.order_id,
      image: ['', '', ''],
      buyer_message: '',
      file_value: ['', '', '']
    }
  },
  mounted () {
  },
  computed: {
  },
  created: function () {
  },
  methods: {
    submitInformation () {
      addRefundAll(this.order_id, this.buyer_message, this.file_value).then(res => {
        Toast(res.message)
        this.$router.push({ name: 'MemberRefundList' })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    useCrop () {
      let index = this.cropType
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('refund_pic', files)

        uploadRefundImage(formdata).then(res => {
          this.image.splice(index, 1, res.result.pic + '?' + Math.floor(Math.random() * 100))
          this.file_value.splice(index, 1, res.result.file_name)
          this.showCrop = false
          Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    uploadRefundImage (index, event) {
      let that = this
      this.cropType = index
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    }
  }
}
</script>
<style  lang="scss" scoped>
  .member-information {
    background: #fff;
    .image-wrapper{display:flex;margin:1rem;}
    .user-avatar {
    flex:1;
    border:1px solid #eee;
      position: relative;
      width: 5rem;
      height: 5rem;
      margin: 0 auto;
      text-align: center;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 5rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(0, 0, 0, 0.5)
    }
  }

</style>
